<template>
    <v-container class="pa-0" style="width: auto;">
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                icon
                style="width: auto;height: auto;"
                v-bind="attrs"
                small
                v-on="on"
                @click="openLink('https://abriron.com/%d8%a8%d8%b1%d9%88%d8%b2%d8%b1%d8%b3%d8%a7%d9%86%db%8c-%d9%87%d8%a7/')"
                >
                    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.6107 10.8674C16.4534 12.0674 15.9723 13.2019 15.2192 14.1492C14.4661 15.0966 13.4693 15.821 12.3357 16.2449C11.2021 16.6688 9.97454 16.7761 8.7846 16.5554C7.59467 16.3346 6.48727 15.7941 5.58118 14.9918C4.67509 14.1895 4.00448 13.1557 3.64128 12.0013C3.27808 10.8468 3.23599 9.61527 3.51952 8.43872C3.80305 7.26216 4.4015 6.18498 5.2507 5.32269C6.0999 4.46041 7.16781 3.84555 8.33989 3.54406C11.5891 2.71073 14.9524 4.38323 16.1941 7.49989" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M16.6667 3.33301V7.49967H12.5" stroke="black" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </v-btn>
            </template>
            <span>{{ $t('updated') }}</span>
        </v-tooltip>
    </v-container>
</template>

<script>
export default {
  methods: {
    openLink (link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
